import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export function AnnouncementBar() {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isOverflowing, setIsOverflowing] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const measureRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Cíl: 19. prosince 2025, 23:59:59 v časové zóně Helsinky (Europe/Helsinki)
    const getTargetDateUTC = () => {
      // Pro prosinec 2025: Helsinky je v zimním čase = UTC+2
      // Takže: 2025-12-19 23:59:59 v Helsinkách = 2025-12-19 21:59:59 UTC
      return new Date('2025-12-19T21:59:59.000Z');
    };

    const targetDateUTC = getTargetDateUTC();

    const updateCountdown = () => {
      const now = new Date();
      const difference = targetDateUTC.getTime() - now.getTime();

      if (difference > 0) {
        const totalSeconds = Math.floor(difference / 1000);
        const days = Math.floor(totalSeconds / (24 * 60 * 60));
        const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        const seconds = totalSeconds % 60;
        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        // Deadline prošel
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    // První aktualizace okamžitě
    updateCountdown();

    // Pak každou sekundu
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current && measureRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const contentWidth = measureRef.current.scrollWidth;
        setIsOverflowing(contentWidth > containerWidth);
      }
    };

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [timeLeft, t]);

  const renderContent = () => (
    <div className="flex items-center gap-3 whitespace-nowrap">
      <span>{t('announcement.christmasDiscount')}</span>
      <div className="flex items-center gap-2">
        {/* notranslate a translate="no" zabrání Google Translate v modifikaci DOM uzlu, což způsobovalo pády */}
        <span className="font-bold notranslate" translate="no">
          {timeLeft.days > 0 && `${timeLeft.days}d `}
          {String(timeLeft.hours).padStart(2, '0')}:{String(timeLeft.minutes).padStart(2, '0')}:{String(timeLeft.seconds).padStart(2, '0')}
        </span>
      </div>
    </div>
  );

  return (
    <div
      ref={containerRef}
      className="sticky top-0 z-50 bg-secondary text-primary font-medium leading-tight overflow-hidden border-b border-border"
    >
      {/* Invisible measurement element */}
      <div ref={measureRef} className="absolute opacity-0 pointer-events-none whitespace-nowrap px-4 py-2">
        {renderContent()}
      </div>

      <div className="py-2 w-full">
        {isOverflowing ? (
          <div className="animate-marquee flex w-max">
            <div className="px-8">{renderContent()}</div>
            <div className="px-8">{renderContent()}</div>
            {/* Third copy for smoother loop on very wide screens if needed, but 2 usually enough checks logic */}
            <div className="px-8">{renderContent()}</div>
            <div className="px-8">{renderContent()}</div>
          </div>
        ) : (
          <div className="flex justify-center px-4">
            {renderContent()}
          </div>
        )}
      </div>
    </div>
  );
}

